import { dispatch } from 'nike-re-framejs';
import { useEffect } from 'react';
import {
    overviewBetsPush,
    overviewBetsSnapshot,
    overviewTournamentsPush,
    overviewTournamentsSnapshot,
    sportsPush,
    sportsSnapshot
} from './handlers';
import { PUSH_PATHS } from '../paths';
import { subscribePath, unsubscribePath } from '../pushSubscriptions';
import { withVersionCheck } from '../versioningUtils';

export function useSportsPush() {
    useEffect(() => {
        const path = PUSH_PATHS.sportMenu();
        subscribePath(path, {
            onSnapshot: data => dispatch(sportsSnapshot(data)),
            onMessage: data => dispatch(sportsPush(data))
        });
        return () => unsubscribePath(path);
    }, []);
}

export function useSportTournamentsPush(sportCode: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverview(sportCode);
        subscribePath(path, {
            onSnapshot: data => dispatch(overviewTournamentsSnapshot(sportCode, data)),
            onMessage: data => dispatch(overviewTournamentsPush(sportCode, data))
        });
        return () => unsubscribePath(path);
    }, [sportCode]);
}

export function useSportBetsPush(sportCode: string, marketId: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewBets(sportCode, marketId);
        subscribePath(
            path,
            withVersionCheck({
                onSnapshot: data => dispatch(overviewBetsSnapshot(sportCode, data)),
                onMessage: data => dispatch(overviewBetsPush(sportCode, data))
            })
        );
        return () => unsubscribePath(path);
    }, [sportCode, marketId]);
}

export function useTournamentBetsPush(sportCode: string, tournamentId: string, marketId: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewBetsTournament(sportCode, tournamentId, marketId);
        subscribePath(
            path,
            withVersionCheck({
                onSnapshot: data => dispatch(overviewBetsSnapshot(sportCode, data)),
                onMessage: data => dispatch(overviewBetsPush(sportCode, data))
            })
        );
        return () => unsubscribePath(path);
    }, [sportCode, tournamentId, marketId]);
}

export function useMatchBetsPush(sportCode: string, matchId: string, marketId: string) {
    useEffect(() => {
        const path = PUSH_PATHS.sportOverviewBetsMatch(sportCode, matchId, marketId);
        subscribePath(
            path,
            withVersionCheck({
                onSnapshot: data => dispatch(overviewBetsSnapshot(sportCode, data)),
                onMessage: data => dispatch(overviewBetsPush(sportCode, data))
            })
        );
        return () => unsubscribePath(path);
    }, [sportCode, matchId, marketId]);
}
